import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Createnft from "Pages/Createnft/Createnft";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
export default function Createnfttheme() {
  return (
    <>
      {/* <Header /> */}
      <Createnft />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
